var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.$t('End User Licence Agreement')))]),_c('p',[_vm._v(_vm._s(_vm.$t('EULA intro')))]),_c('div',{staticClass:"content"},[_c('ul',_vm._l((7),function(x){return _c('li',{staticClass:"has-text-justified"},[_vm._v(_vm._s(_vm.$t('EULA item ' + x)))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }